<template>
  <div class="contents-wrap">
    <div
      class="demo-infinite-container"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <a-list
        :data-source="dataSourse"
        :grid="{ xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }"
      >

        <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
          <div class="dir-wrapper">
            <a-checkbox
              class="item-base"
              :key="item.id"
              @change="(e)=>onChange(e,item.id,index)"
              v-model="item.isChecked"
            >
              <div class="material-item">
                <div class="item-img">
                  <img :src="item.thumb_path"/>
                </div>
                <span class="item-name">{{ item.scene_title }}</span>
              </div>
            </a-checkbox>
          </div>
        </a-list-item>
        <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div>
      </a-list>
    </div>
  </div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import { mapGetters } from "vuex";

export default {
  name: "SceneList",
  directives: { infiniteScroll },
  props: {
    type:{
      type:Number,
      default:0
    },
  },
  data() {
    return {
      loading: false,
      busy: false,
      dataSourse: [],
      checkedState:false,
    };
  },
  beforeMount() {},
  watch: {},
  computed: {
    ...mapGetters(["vrbase"]),
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      for (const i in this.vrbase.scenes){
        this.vrbase.scenes[i].isChecked = false;
        this.dataSourse.push(this.vrbase.scenes[i])
      }
      this.loading = false;
    },
    onChange(e,id,index) {
        for (let i = 0; i < this.dataSourse.length; i++) {
          this.dataSourse[i].isChecked = false;
        }
        this.dataSourse[index].isChecked = true;
        this.$forceUpdate()
      this.$emit("selected", this.dataSourse[index]);
    },
  },
};
</script>

<style lang="less" scoped>
.dir-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 110px;
}
@media (max-width: 767px) {
  .dir-wrapper {
    height: 70px;
  }
}
.card-wrapper {
  width: 100px;
  height: 100px;
}
.contents-wrap {
  .upload-btn {
    position: absolute;
    top: -6px;
    right: 0;
    flex-shrink: 0;
  }
  .box-titles {
    position: relative;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }
}
.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 400px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.item-base {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
}
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin-right: 5px;
}
.item-img img {
  width: 100%;
}
.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
}
.dir-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dir-wrapper:hover {
  cursor: pointer;
  color: #1890ff;
}
</style>
